import gql from 'graphql-tag';

export const byIntegrationCountFragment = gql`
  fragment byIntegrationCountFragment on ByIntegrationCount {
    integrationID
    count
  }
`;
export default byIntegrationCountFragment;
